module.exports = __webpack_public_path__ + "static/media/Vector.9c34bd67.svg";